//  header text animation js
document.addEventListener("DOMContentLoaded", function () {
  const lines = [
    "Free Samples on ₹1500+",
    "Extra 5% on Prepaid",
    "Free Duffle on ₹2000+",
    "Dispatched In 24 Hours",
  ];

  const lineTextElement = document.getElementById("lineText");
  let lineIndex = 0;

  function showNextLine() {
    lineTextElement.classList.remove("show");
    setTimeout(() => {
      lineTextElement.textContent = lines[lineIndex];
      lineTextElement.classList.add("show");
      lineIndex = (lineIndex + 1) % lines.length;
    }, 200); // wait for fade out before switching text
  }

  // Start loop
  showNextLine();
  setInterval(showNextLine, 2500); // change line every 2.5 seconds
});

// col tabs
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll("#tabs ul li a.tabing");
  const contents = document.querySelectorAll(".tabs div.tabs-box");

  function hideAllTabs() {
    contents.forEach((content) => (content.style.display = "none"));
    tabs.forEach((tab) => tab.classList.remove("active"));
  }

  function showTab(id) {
    hideAllTabs();
    document.querySelector(id).style.display = "block";
    document.querySelector(`a[href="${id}"]`).classList.add("active");
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", function (event) {
      event.preventDefault();
      showTab(this.getAttribute("href"));
    });
  });

  if (tabs.length > 0) {
    showTab(tabs[0].getAttribute("href"));
  }
});

// faq js
document.addEventListener("DOMContentLoaded", function () {
  const faqQuestions = document.querySelectorAll(".faq-question");

  faqQuestions.forEach(function (question) {
    const answer = question.nextElementSibling;

    if (answer) {
      // Set initial styles for smooth transitions
      answer.style.maxHeight = "0";
      answer.style.overflow = "hidden";
      answer.style.transition = "max-height 0.3s ease-out";
    }

    question.addEventListener("click", function () {
      const isActive = this.classList.contains("active");

      // Close all other questions
      faqQuestions.forEach(function (q) {
        q.classList.remove("active");
        const ans = q.nextElementSibling;
        if (ans) ans.style.maxHeight = "0";
        const iconPlus = q.querySelector(".icon-plus");
        const iconMinus = q.querySelector(".icon-minus");
        if (iconPlus) iconPlus.style.display = "inline";
        if (iconMinus) iconMinus.style.display = "none";
      });

      // Toggle the clicked question
      if (!isActive) {
        this.classList.add("active");
        if (answer) {
          answer.style.maxHeight = answer.scrollHeight + "px";
        }
        const iconPlus = this.querySelector(".icon-plus");
        const iconMinus = this.querySelector(".icon-minus");
        if (iconPlus) iconPlus.style.display = "none";
        if (iconMinus) iconMinus.style.display = "inline";
      }
    });
  });

  // Open the first question by default
  const firstQuestion = faqQuestions[0];
  if (firstQuestion) {
    firstQuestion.click();
  }
});


// copy code
document.addEventListener("DOMContentLoaded", function () {
  const codeEl = document.getElementById("discount-code");
  if (codeEl) {
    codeEl.addEventListener("click", function () {
      navigator.clipboard.writeText(codeEl.textContent).then(function () {
        alert("Copied: " + codeEl.textContent);
      });
    });
  }
});

// blogs tab
document.addEventListener("DOMContentLoaded", function () {
  let e = document.querySelectorAll(".tab"),
    t = document.querySelectorAll(".article");
  e.forEach((s) => {
    s.addEventListener("click", function () {
      e.forEach((e) => e.classList.remove("active")),
        this.classList.add("active");
      let s = this.getAttribute("data-filter");
      t.forEach((e) => {
        "all" === s
          ? (e.style.display = "block")
          : e.getAttribute("data-category").includes(s)
          ? (e.style.display = "block")
          : (e.style.display = "none");
      });
    });
  });
});

//  pdp accordion
document.querySelectorAll(".product__accordion details").forEach((detail) => {
  const summary = detail.querySelector("summary");
  const content = detail.querySelector(".accordion__content");

  summary.addEventListener("click", function (event) {
    event.preventDefault(); // Default behavior prevent karega taake animation custom ho

    if (detail.hasAttribute("open")) {
      content.style.maxHeight = content.scrollHeight + "px"; // Ensure full height before collapsing
      setTimeout(() => {
        content.style.maxHeight = "0";
      }, 10); // Small delay for smooth transition
      setTimeout(() => {
        detail.removeAttribute("open");
      }, 300); // Delay equal to CSS transition time
    } else {
      detail.setAttribute("open", "true");
      content.style.maxHeight = "0"; // Reset before expanding
      setTimeout(() => {
        content.style.maxHeight = content.scrollHeight + "px";
      }, 10);
    }
  });
});

// customer video
function playVideo(id) {
  // Pause all videos
  document.querySelectorAll("video").forEach((video) => {
    video.pause();
    video.currentTime = 0;
    video.style.display = "none";
  });

  // Show all posters
  document.querySelectorAll(".video-poster").forEach((poster) => {
    poster.style.display = "block";
  });

  // Play the selected video
  const video = document.getElementById("video-" + id);
  const poster = document.getElementById("poster-" + id);

  if (video && poster) {
    poster.style.display = "none";
    video.style.display = "block";
    video.play();
  }
}

document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth >= 990) {
    document.querySelectorAll('.header__inline-menu details').forEach(function(details) {

      details.addEventListener('mouseenter', function() {
        this.setAttribute('open', '');
      });

      details.addEventListener('mouseleave', function() {
        this.removeAttribute('open');
      });

    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
    const activeTab = document.querySelector('.blog-tabs .tab.active');
    if (activeTab) {
        activeTab.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest'
        });
    }

});